export default {
    'general': {
        'versioning': 'Verzioniranje',
        'dashboard': 'Nadzorna plošča',
        'email': 'E-pošta',
        'username': 'Uporabniško ime',
        'name': 'Ime',
        'password': 'Geslo',
        'actions': 'Dejanja',
        'login': 'Prijava',
        'logout': 'Odjava',
        'no_results': 'Ni rezultatov',
        'success': 'Uspeh',
        'warning': 'Opozorilo',
        'remember_me': 'Zapomni si me',
        'error': 'Napaka',
        'edit': 'Uredi',
        'details': 'Podrobnosti',
        'add': 'Dodaj',
        'delete': 'Izbriši',
        'yes': 'Da',
        'no': 'Ne',
        'cancel': 'Prekliči',
        'back': 'Nazaj',
        'image': 'Slika',
        'filters': 'Filtri',
        'remove_filters': 'Odstrani filtre',
        'default': 'Privzeto',
        'save': 'Shrani',
        'key': 'Ključ',
        'distribution_zone': 'Distribucijska cona',
        'preview': 'Predogled',
        'icon': 'Ikona',
        'last_edited': 'Nazadnje urejeno',
        'unknown': 'Neznano',
        'latest_version': 'Zadnja različica',
        'taxpayer': 'Davčni zavezanec',
        'country': 'Država',
        'date_at': 'ob',
        'drag_and_drop_files_to_upload': 'Povlecite in spustite datoteke za nalaganje',
        'export': 'Izvoz',
        'options': 'Opcije',
        'download': 'Prenos'
    },
    'warning': {
        'file_preview_not_available': 'Predogled ni na voljo za to vrsto datoteke.'
    },
    'errors': {
        'generic_error': 'Prišlo je do napake',
        'login': 'Napaka pri prijavi',
        'logout': 'Napaka pri odjavi',
        'incorrect_password': 'Staro geslo ni pravilno',
        'invalid_data': 'Prejeti so neveljavni podatki',
        'not_found': 'Podatkov ni mogoče najti',
        'user_exist': 'Uporabnik s tem e-naslovom že obstaja',
        'load_data': 'Napaka pri nalaganju podatkov',
        'on_upload_image': 'Napaka pri nalaganju slik',
        'on_upload_file': 'Napaka pri nalaganju datotek',
        'on_publish': 'Napaka pri objavljanju',
        'on_approve': 'Napaka pri odobritvi',
        'on_download': 'Napaka pri prenosu datoteke',
        'on_add': 'Napaka pri dodajanju',
        'on_edit': 'Napaka pri urejanju',
        'on_delete': 'Napaka pri brisanju',
        'on_sort': 'Napaka pri razvrščanju',
        'unauthorized': 'Nepooblaščeno',
        'user_does_not_exist': 'Uporabnik ne obstaja',
        'country_not_found': 'Država ni bila najdena',
        'country_not_specified': 'Država ni določena',
        'tax_number_not_found': 'Davčna številka ni najdena',
        'company_with_vat_number_exists': 'Podjetje s to davčno številko že obstaja',
        'username_exists': 'To uporabniško ime že obstaja. Prosimo, uporabite drugo.',
        'email_exists': 'Ta e-naslov že obstaja. Prosimo, uporabite drugega.',
        'failed_to_insert': 'Vstavljanje ni uspelo',
        'file_to_big': 'Datoteka je prevelika',
        'missing_roles': 'Manjkajoče vloge',
        'no_roles_selected': 'Uporabnik mora imeti izbrano vsaj eno vlogo',
        'fetching_data': 'Napaka pri pridobivanju podatkov',
        'deleting_default_data': 'Napaka pri brisanju privzetih podatkov',
        'data_already_exists': 'Podatki že obstajajo',
        'unable_to_retrieve_extension': 'Ni mogoče pridobiti končnice',
        'role_exists': 'Vloga že obstaja',
        'role_does_not_exist': 'Vloga ne obstaja',
        'no_access': 'Ni dostopa'
    },
    'success': {
        'on_add': 'Uspešno dodano',
        'on_edit': 'Uspešno urejeno',
        'on_delete': 'Uspešno izbrisano',
        'on_update': 'Uspešno posodobljeno',
        'on_remove': 'Uspešno odstranjeno',
        'on_publish': 'Uspešno objavljeno',
        'on_approve': 'Uspešno odobreno',
        'on_sort': 'Uspešno razvrščeno',
        'on_change_password': 'Geslo je bilo uspešno spremenjeno',
        'channel_package_activated': 'Paket kanalov uspešno aktiviran',
        'channel_package_deactivated': 'Paket kanalov uspešno deaktiviran'
    },
    'confirmations': {
        'general': 'Ste prepričani, da želite nadaljevati?',
        'header': 'Ali ste prepričani',
        'delete_row': 'Ali ste prepričani, da želite izbrisati',
        'deactivate_row': 'Ali ste prepričani, da želite deaktivirati',
        'publish': 'Ali ste prepričani, da želite objaviti na',
        'approve': 'Ali ste prepričani, da želite odobriti'
    },
    'table': {
        'no_data': 'Ni podatkov za prikaz',
        'press_enter_search': 'Pritisnite enter za iskanje',
        'search': 'Išči po',
        'select_option': 'Izberite možnost',
        'select_date': 'Izberite datum',
        'select_range': 'Izberite razpon',
        'of': 'od'
    },
    'file': {
        'drag_and_drop': 'Povlecite in spustite datoteke sem za nalaganje.'
    },
    'comment': {
        'reply': 'Odgovori',
        'replies': 'Odgovori',
        'show_more_replies': 'Prikaži več odgovore',
        'show_replies': 'Prikaži odgovore',
        'hide_replies': 'Skrij odgovore',
        'attachments': 'Priloge',
        'comment': 'Komentar',
        'comments': 'Komentarji',
        'edited': 'urejeno',
        'deleted': 'Komentar izbrisan',
        'deleted_at': 'Izbrisano',
        'delete': 'comment',
        'attachment': 'Priloga',
        'add_comment': 'Dodaj komentar',
        'add_comment_text': 'Dodaj komentar (uporabi {\'@\'} za omenjanje)'
    },
    'language': {
        'slovenian': 'Slovenščina',
        'english': 'Angleščina',
        'croatian': 'Hrvaščina'
    },
    'signature': {
        'signature': 'Podpis',
        'sign': 'Podpiši',
        'cancel': 'Prekliči',
        'clear': 'Počisti'
    },
    'lead': {
        'lead': 'Priložnost',
        'leads': 'Priložnosti',
        'add': 'Dodaj priložnost',
        'priority': 'Prioriteta',
        'save': 'Shrani',
        'project_milestones': 'Mejniki projekta',
        'hide_devices_page': 'Ne prikaži strani z napravami',
        'devices_page_shown': 'Prikaz strani z napravami',
        'company': {
            'add': 'Dodaj podjetje',
            'edit': 'Uredi podatke podjetja',
            'does_not_exist': 'Podjetje ne obstaja',
            'select': 'Izberi podjetje',
            'company': 'Podjetje'
        },
        'active_seller': {
            'edit': 'Uredi aktivnega prodajalca'
        },
        'maintenance_worker': {
            'edit': 'Uredi serviserja'
        },
        'contact': {
            'add': 'Dodaj kontakt',
            'select': 'Izberi kontakt',
            'info': 'Kontaktni podatki',
            'contact': 'Kontakt',
            'contact_information': 'Kontaktni podatki'
        },
        'business_unit': {
            'business_unit': 'Poslovna enota',
            'business_units': 'Poslovne enote',
            'add_new': 'Dodaj novo poslovno enoto',
            'created': 'Ustvarjeno',
            'last_edited': 'Nazadnje urejeno',
            'select': 'Izberi',
            'business_unit_select': 'Izbor poslovne enote',
            'edit': 'Uredi',
            'edit_business_unit': 'Uredi poslovno enoto',
            'remove': 'Odstrani',
            'status': 'STATUS',
            'name': 'Ime',
            'address': 'Naslov',
            'add': 'Dodaj poslovno enoto',
            'primary_activity': 'Primarna dejavnost',
            'view': 'Poglej'
        },
        'status': {
            'status': 'Status priložnosti',
            'draft': 'Osnutek',
            'offer_sent': 'Poslana ponudba',
            'data_retrieval': 'Pridobitev podatkov',
            'data_entry': 'Vnos podatkov',
            'installation': 'Namestitev',
            'rejected': 'Zavrnjeno',
            'additional_requirements': 'Dodatne zahteve',
            'completed': 'Zaključeno',
            'rejection_reason': 'Razlog za zavrnitev',
            'reject': 'Zavrni',
            'empty': 'PRAZNO',
            'started': 'ZAČETO',
            'finished': 'ZAKLJUČENO'
        },
        'tasks': {
            'contact_request': 'Zahteva za kontakt',
            'presentation_to_client': 'Predstavitev stranki',
            'requirements_analysis': 'Analiza zahtev',
            'offer_and_contract_prepare': 'Priprava ponudbe in pogodbe',
            'offer_and_contract_presentation': 'Predstavitev ponudbe in pogodbe',
            'estimated_finish_date': 'Predviden datum zaključka',
            'estimated_finish': 'Predviden zaključek',
            'finished': 'Zaključeno',
            'not_finished': 'Ni zaključeno',
            'tasks': 'Naloge',
            'mark_as_finished': 'Označi kot zaključeno',
            'mark_as_not_finished': 'Označi kot ne-zaključeno'
        },
        'software_offer': {
            'software_offer': 'Ponudba programske opreme',
            'licence': 'Licenca',
            'discount': 'Popust',
            'desktop_devices': 'Namizne naprave',
            'mobile_devices': 'Mobilne naprave',
            'number_of_products': 'Število izdelkov',
            'number_of_ingredients': 'Število sestavin',
            'payment_type': 'Vrsta plačila',
            'payment_month': 'Mesec plačila',
            'payment_frequency': 'Pogostost plačil',
            'wolt_integration_enabled': 'Wolt integracija omogočena',
            'return_packaging_integration_enabled': 'Integracija povratne embalaže omogočena',
            'installation_option': 'Opcija namestitve',
            'installation_price': 'Cena namestitve',
            'option': {
                'according_to_price_list': 'Po ceniku',
                'discount_100_percentages': '100 % popust',
                'hide_table_on_offer': 'Skrij tabelo v ponudbi',
                'custom_price': 'Cena po meri'
            },
            'software': 'Programska oprema',
            'imprion_pos': 'Imprion Blagajna'
        },
        'hardware_offer': {
            'hardware': 'Strojna oprema',
            'client_has_all_hardware': 'Stranka ima vso strojno opremo',
            'hardware_offer': 'Ponudba strojne opreme',
            'hardware_offers': 'Ponudbe strojne opreme',
            'pos_hardware': 'POS strojna oprema',
            'is_custom_hardware': 'Je strojna oprema po meri',
            'pos_hardware_custom': 'POS strojna oprema po meri',
            'quantity': 'Količina',
            'price': 'Cena',
            'price_per_item': 'Cena na enoto',
            'price_with_vat': 'Cena z DDV',
            'price_with_discount': 'Cena s popustom',
            'total_price': 'Skupna cena',
            'discount': 'Popust',
            'add': 'Dodaj',
            'edit': 'Uredi',
            'cancel': 'Prekliči',
            'vat': 'DDV'
        },
        'payment_gateway_status': {
            'payment_gateway_status': 'Status plačilnega prehoda',
            'using_card_payments': 'Uporaba kartičnih plačil',
            'current_card_payment_provider': 'Trenutni ponudnik kartičnih plačil',
            'custom_card_system': 'Kartični sistem po meri',
            'want_to_use_card_system': 'Želi uporabljati kartični sistem',
            'provider': 'Ponudnik'
        },
        'connection_schedule': {
            'connection_schedule': 'Urnik priklopa',
            'connection_type': 'Kdaj se želite povezati',
            'connection_date': 'Datum priklopa',
            'connection': 'Priklop'
        },
        'additional_requests': {
            'additional_requests': 'Dodatne zahteve',
            'additional_request': 'Dodatna zahteva',
            'request': 'Zahteva',
            'priority': 'Prioriteta',
            'add': 'Dodaj',
            'edit': 'Uredi',
            'cancel': 'Prekliči'
        },
        'network_infrastructure': {
            'network_infrastructure': 'Omrežna infrastruktura',
            'is_wifi_setup': 'Je WiFi nastavljen',
            'business_unit_wifi_covered': 'Poslovna enota pokrita z WiFi',
            'is_wifi_stable': 'Je WiFi stabilen',
            'multiple_ap_in_business_unit': 'Več dostopnih točk (AP) v poslovni enoti',
            'multiple_ap': 'Več AP',
            'ap_has_roaming': 'AP ima gostovanje (roaming)',
            'ap_manufacturer': 'Proizvajalec AP',
            'ap_manufacturer_custom': 'Proizvajalec AP po meri',
            'network_manager_type': 'Vrsta upravitelja omrežja',
            'network_manager': 'Upravitelj omrežja',
            'network_manager_name': 'Ime upravitelja omrežja',
            'can_devices_sync': 'Se naprave lahko sinhronizirajo'
        },
        'priority_value': {
            'low': 'Nizka',
            'medium': 'Srednja',
            'high': 'Visoka',
            'urgent': 'Nujno',
            'critical': 'Kritično'
        },
        'sale': 'Prodaja',
        'generating_quote': 'Generiranje ponudbe',
        'printout_of_entered_data': 'Izpis vnesenih podatkov',
        'create_new_company': 'Ustvari novo podjetje'
    },
    'editor': {
        'heading': 'Naslov 1',
        'subheading': 'Naslov 2',
        'subheading_3': 'Naslov 3',
        'base': 'Osnova',
        'bold': 'Krepko',
        'italic': 'Ležeče',
        'underline': 'Podčrtano',
        'left_align': 'Levo',
        'center_align': 'Sredina',
        'right_align': 'Desno',
        'justify_align': 'Poravnano',
        'ordered_list': 'Oštevilčen seznam',
        'bullet_list': 'Seznam z alinejami',
        'small': 'Majhno',
        'normal': 'Normalno',
        'large': 'Veliko',
        'huge': 'Ogromno',
        'link': 'Povezava'
    },
    'months': {
        'january': 'Januar',
        'february': 'Februar',
        'march': 'Marec',
        'april': 'April',
        'may': 'Maj',
        'june': 'Junij',
        'july': 'Julij',
        'august': 'Avgust',
        'september': 'September',
        'october': 'Oktober',
        'november': 'November',
        'december': 'December'
    },
    'licences': {
        'essential': 'Essential',
        'standard': 'Standardno',
        'premium': 'Premium'
    },
    'timelee': {
        'without': 'Brez',
        'basic': 'Osnovno',
        'pro': 'Pro',
        'discount_on_timelee': 'Popust na timelee'
    },
    'payment_frequencies': {
        'monthly': 'Mesečno',
        'instalment_plan': 'Obročno odplačevanje',
        'yearly': 'Letno'
    },
    'payment_interval': {
        'payment_interval': 'Plačilni interval',
        'three_months': 'Vsake 3 mesece',
        'four_months': 'Vsake 4 mesece',
        'six_months': 'Vsakih 6 mesecev'
    },
    'card_payment_providers': {
        'besteron': 'Besteron',
        'hobex': 'Hobex',
        'wordline': 'Wordline',
        'other': 'Drugo'
    },
    'connection_types': {
        'asap': 'Čim prej',
        'no_preference': 'Brez preference',
        'fixed_date': 'Fiksni datum'
    },
    'ap_roaming_types': {
        'yes': 'Da',
        'no': 'Ne',
        'unknown': 'Neznano'
    },
    'ap_manufactures': {
        'ubiquiti': 'Ubiquiti',
        'tp_link': 'TP link',
        'tenda': 'Tenda',
        'mikrotik': 'Mikrotik',
        'asus': 'Asus',
        'zyxel': 'Zyxel',
        'd_link': 'D link',
        'cisco': 'Cisco',
        'huawei': 'Huawei',
        'ruijie_reyeea': 'Ruijie-ReyeeA',
        'aruba': 'Aruba',
        'ruckus': 'Ruckus',
        'xirrus': 'Xirrus',
        'cambium': 'Cambium',
        'other': 'Drugo'
    },
    'network_manager_types': {
        'inner': 'Notranji',
        'outer': 'Zunanji'
    },
    'primary_activities': {
        'restaurant': 'Restavracija',
        'food_truck': 'Okrepčevalnica (Food truck)',
        'hairdresser': 'Frizerski salon',
        'beauty_salon': 'Kozmetični salon',
        'other_service_activity': 'Druge storitvene dejavnosti',
        'other': 'Drugo'
    },
    'company': {
        'company': 'Podjetje | Podjetja',
        'company_that_not_exists': 'Podjetje, ki ne obstaja | Podjetja, ki ne obstajajo',
        'add': 'Dodaj podjetje',
        'edit': 'Uredi podjetje',
        'official_name': 'Uradni naziv',
        'alias': 'Alias',
        'country': 'Država',
        'country_name': 'Ime države',
        'country_code': 'Koda države',
        'tax_number': 'Davčna številka',
        'address': 'Naslov',
        'is_tax_payer': 'Je davčni zavezanec',
        'contact': {
            'title': 'Kontakt podjetja | Kontakti podjetja',
            'add': 'Dodaj kontakt podjetja',
            'edit': 'Uredi kontakt podjetja',
            'first_name': 'Ime',
            'last_name': 'Priimek',
            'email': 'E-pošta',
            'phone_number': 'Telefonska številka',
            'company_role': 'Vloga v podjetju'
        }
    },
    'business_unit': {
        'business_unit': 'Poslovna enota | Poslovne enote',
        'add': 'Dodaj poslovno enoto',
        'edit': 'Uredi poslovno enoto',
        'primary_activity': 'Primarna dejavnost',
        'movable': 'Premično',
        'is_movable': 'Je premično',
        'activity': {
            'catering_establishment': 'Gostinski obrat',
            'food_truck': 'Tovornjak s hrano',
            'hair_salon': 'Frizerski salon',
            'beauty_salon': 'Kozmetični salon',
            'other_service_activity': 'Druge storitvene dejavnosti',
            'other': 'Drugo'
        }
    },
    'profile': {
        'profile': 'Profil',
        'edit_profile': 'Uredi profil',
        'old_password': 'Staro geslo',
        'new_password': 'Novo geslo',
        'confirm_password': 'Potrdi geslo',
        'change_password_text': 'Če je polje za geslo prazno, geslo ne bo spremenjeno.',
        'change_password': 'Spremeni geslo'
    },
    'seller': {
        'seller': 'Prodajalec | Prodajalci',
        'active_seller': 'Aktiven prodajalec',
        'maintenance_worker': 'Serviser',
        'add': 'Dodaj prodajalca',
        'edit': 'Uredi prodajalca',
        'first_name': 'Ime',
        'last_name': 'Priimek',
        'email': 'E-pošta',
        'phone_number': 'Telefonska številka',
        'language': 'Jezik',
        'password': 'Geslo',
        'change_password': 'Spremeni geslo',
        'new_password': 'Novo geslo',
        'confirm_password': 'Potrdi geslo',
        'role': {
            'role': 'Vloga | Vloge',
            'view_all_leads': 'Ogled vseh priložnosti',
            'reassign_leads': 'Ponovna dodelitev priložnosti',
            'remove_leads': 'Brisanje priložnosti',
            'manage_users': 'Upravljanje uporabnikov'
        }
    },
    'current_software': {
        'current_software': 'Trenutna programska oprema | Trenutna programska oprema',
        'current_software_custom': 'Trenutna programska oprema po meri'
    },
    'lead_source': {
        'lead_source': 'Vir priložnosti | Viri priložnosti',
        'lead_source_custom': 'Vir priložnosti po meri'
    },
    'besteron': {
        'payment_data': 'Podatki za plačilo Besteron',
        'company_name': 'Ime podjetja',
        'activity': 'Dejavnost',
        'activity_suggestion': '(restavracija, trgovina,...)',
        'activity_custom': 'Vnesi dejavnost',
        'pos_terminal_location': 'Lokacija POS terminala',
        'pos_terminal_location_suggestion': 'naslov',
        'location_name': 'Ime lokacije',
        'location_name_suggestion': 'ime trgovine, lokala',
        'contact_person': 'Kontaktna oseba',
        'email': 'E-pošta',
        'email_suggestion': 'bodo prihajali izpiski',
        'phone_number': 'Telefonska številka',
        'tax_number': 'Davčna številka',
        'registration_number': 'Matična števila',
        'iban': 'IBAN',
        'expected_traffic': 'Pričakovan promet',
        'annual_gross_turnover': 'Letni bruto promet',
        'gross_card_turnover': 'Bruto kartični promet',
        'one_time_maximum_payment': 'Enkratno maksimalno plačilo',
        'average_card_payment': 'Povprečno kartično plačilo',
        'minimum_transaction_fee': 'Minimalna transakcijska provizija',
        'number_of_pos_terminals': 'Število pos terminalov',
        'owner_of_space_or_tenats': 'Lastnik prostora / najemnik',
        'owner_of_space': 'Lastnik prostora',
        'space_rental': 'Najem prostora',
        'wifi_or_lte': 'WiFi / LTE',
        'wifi': 'WiFi',
        'lte': 'LTE',
        'purchase_of_terminal_or_rental': 'Nakup terminala / Najem terminala',
        'purchase_of_terminal': 'Nakup terminala',
        'terminal_rental': 'Najem terminala',
        'personal_card_image': 'Slika osebne kartice',
        'name_of_terminal': 'Ime terminala',
        'company_data': 'Podatki o podjetju',
        'turnover': 'Promet',
        'other': 'Ostalo',
        'start_of_billing': 'Pričetek obračuna terminala',
        'accounting_period': 'Obračunsko obdobje',
        'daily': 'Dnevno',
        'weekly': 'Tedensko',
        '14_daily': '14 dnevno',
        'monthly': 'Mesečno',
        'term_terminal': 'Ročnost najema terminala',
        'short_term': 'Kratkoročno',
        'long_term': 'Dolgoročno'
    },
    'equipment': {
        'card_payment_equipment': 'Oprema za plačilo s kartico | Oprema za plačilo s kartico',
        'add_card_payment_equipment': 'Dodaj opremo za plačilo s kartico',
        'edit_card_payment_equipment': 'Uredi opremo za plačilo s kartico',
        'color': 'Barva',
        'monthly_price': 'Mesečna cena',
        'one_time_price': 'Enkratna cena',
        'bought': 'Kupljeno',
        'not_bought': 'Ni kupljeno',
        'provider_name': 'Ime ponudnika'
    }
}
